import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  template: `
    @if (data.showButton) {
      <div>
        @if (!loading) {
          <p (click)="clickButton()" class="btn btn-primary m-0 action-btn"
            [nbTooltipDisabled]="!data.tooltip" [nbTooltip]="data.tooltip" nbTooltipStatus="default" nbTooltipPlacement="bottom">
            <nb-icon icon="download-outline"></nb-icon>
          </p>
        }
        @if (loading) {
          <i class="fa fa-spinner fa-spin"></i>
        }
      </div>
    }
    `,
  styleUrls: ['./download-button.component.scss'],
})
export class DownloadButtonComponent {
  @Input()
  data: any;
  loading = false;

  constructor() {}

  clickButton() {
    event.preventDefault();
    event.stopPropagation();
    if (this.data?.action) {
      this.loading = true;
      this.data.action(this.data.id, () => {
        this.loading = false;
      });
    }
  }
}
